
import { DeputyEffects } from '../effects/deputy.effects';
import { AdministratorModeEffects } from '../effects/administrator-mode.effects';

export const effects: any[] = [DeputyEffects, AdministratorModeEffects];


export * from '../effects/deputy.effects';
export * from '../effects/administrator-mode.effects';